module.exports = __webpack_public_path__ + "media/images/suyf_laptop_desktop -cb590ff4.png";